import { render } from "./Ratings1.vue?vue&type=template&id=5b0fd065"
import script from "./Ratings1.vue?vue&type=script&lang=js"
export * from "./Ratings1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__